import { changeLoginEmailRequestParamsSchema } from '../../../../../backend/features/types/shared';
import { z } from 'zod';
export const changeLoginEmailDef = {
    name: 'changeLoginEmail',
    requestSchema: changeLoginEmailRequestParamsSchema,
    responseSchema: z.void(),
};
